var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-754 -490)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-95 7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(849 483)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(734.183 501)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#26B963",
    d: "M40.142,17.95a7.715,7.715,0,0,0,6.625-6.9,7.767,7.767,0,0,0-7.4-8.792V.139a.145.145,0,0,0-.236-.107l-4.177,3.2a.138.138,0,0,0,0,.217l4.177,3.2a.146.146,0,0,0,.236-.107V4.433a5.615,5.615,0,0,1,5.364,6.089,5.614,5.614,0,0,1-5.1,5.3,5.529,5.529,0,0,1-5.748-4.78,1.04,1.04,0,1,0-2.053.327A7.616,7.616,0,0,0,40.142,17.95Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.b77c8908d68f964993e5c3bf698c3651.svg";
export { ForwardRef as ReactComponent };